import styled from 'styled-components'

import { HEADER_HEIGHT_DESKTOP } from 'src/views/Quiz/components/Header/styled'
import { media } from 'src/styles/media'
import { Z_INDEX_HEADER } from 'src/constants/z-indexes'

export const HeaderWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: ${HEADER_HEIGHT_DESKTOP}rem;
  padding: 0 3.2rem;
  position: absolute;
  z-index: ${Z_INDEX_HEADER};

  ${media.desktop} {
    z-index: unset;
    position: relative;
    box-shadow: inset 0 -0.1rem 0 0 #eeebeb;
  }
`

export const IconWrap = styled.button`
  padding: 0;
`

export const Button = styled.button`
  padding: 0;

  ${media.desktop} {
    padding-right: 0.8rem;
  }
`

export const DropdownWrap = styled.div`
  position: relative;
`
